import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import AnimationWrapper from 'agency/digital_renderer/themes/RealhubDynamic/ui/AnimationWrapper'
import ElementContainer from '../../ElementContainer'

const findContainer = items => items.find(item => item.item_type === 'container')

const filterImages = (images, filters) => {
  const {
    limit, offset, filterTag, imageType,
  } = filters || {}

  const filterOffset = offset && offset !== 0 ? offset : 0
  const filterLimit = limit ? limit + filterOffset : null

  const limited = filterLimit ? images.slice(filterOffset, filterLimit) : images.slice(filterOffset)

  return limited.filter((image) => {
    const imageTags = image.data && image.data.tags ? image.data.tags : []

    if ((imageType === '' || imageType === image.image_type) && (!filterTag || imageTags.includes(filterTag))){
      return true
    }

    return false
  })
}

const renderImages = (images, imageContainer) => images.map(image => (
  <div key={image.id} style={deviceStyle(imageContainer)}>
    <ElementContainer
      forwardContextToItems={image}
      section={imageContainer}
      renderNested
      render={({ itemComponents }) => itemComponents.map(component => component)}
    />
  </div>
))

const CampaignImages = (props) => {
  const { items, options } = props

  const {
    limit, offset, filterTag, imageType,
  } = options || {}

  const imageContainer = findContainer(items) || {}
  const style = deviceStyle(props)

  const defaultContext = useContext(GlobalContext)
  const { campaignImages } = defaultContext

  const filteredImages = filterImages(campaignImages, {
    limit,
    offset,
    filterTag,
    imageType,
  })

  return (
    <AnimationWrapper options={options}>
      <div style={style}>
        {renderImages(filteredImages, imageContainer)}
      </div>
    </AnimationWrapper>
  )
}

CampaignImages.propTypes = {
  items: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
}

export default CampaignImages
